class ContentTeaserSwipe {
  constructor() {
    this.componentClass = '.js-content-teaser-swipe';
    this.slideClass = '.content-teaser-swipe__slide';

    this.sections = document.querySelectorAll(this.componentClass);

    if (!this.sections.length) return;

    this.init();
  }

  init() {
    this.sections.forEach((section) => {
      this.setupSection(section);
    });
  }

  setupSection(section) {
    const slides = Array.from(
      section.querySelectorAll(this.slideClass)
    );

    if (!slides.length) return;

    this.setHeight(section, slides);

    let lastIndex = 0;

    const onScroll = () => {
      if (window.innerWidth < 768) return;

      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const sectionHeight = section.offsetHeight;

      const maxScrollable =
        sectionHeight - viewportHeight;

      const progress = Math.min(
        Math.max(-rect.top, 0),
        maxScrollable
      );

      const slideRange =
        maxScrollable / slides.length;

      const index = Math.min(
        Math.max(
          Math.floor(progress / slideRange),
          0
        ),
        slides.length - 1
      );

      if (index !== lastIndex) {
        this.updateSlides(slides, index);
        lastIndex = index;
      }
    };

    window.addEventListener(
      'scroll',
      onScroll,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      () => this.setHeight(section, slides)
    );

    onScroll();
  }

  setHeight(section, slides) {
    section.style.height =
      slides.length * 100 + 'vh';
  }

  updateSlides(slides, index) {
    slides.forEach((slide, i) => {
      slide.classList.remove('is-active', 'is-prev');
      slide.style.removeProperty('--prev-index');

      if (i < index) {
        // --prev-index: 1 = directly behind active, 2 = one further back, etc.
        slide.style.setProperty('--prev-index', index - i);
        slide.classList.add('is-prev');
      } else if (i === index) {
        slide.classList.add('is-active');
      }
    });
  }
}

export default ContentTeaserSwipe;